
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community-portal/my-communities",
      function () {
        return require("private-next-pages/community-portal/my-communities/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community-portal/my-communities"])
      });
    }
  